export default __webpack_public_path__ + "static/media/horinzontal-dots.d2a6c7ef.svg";